<div class="modal-header d-flex align-items-center justify-content-between">
  <h4 class="modal-title">Drop Settings</h4>
  <button
    type="button"
    class="btn btn-link p-0 border-0"
    aria-label="Close"
    (click)="cancel()"
  >
    <i class="bi bi-x-lg"></i>
  </button>
</div>

<div class="modal-body">
  <div class="row">
    <!-- Drop Height -->
    <div class="col-md-6 mb-3">
      <label class="form-label">Height (cm)</label>
      <div class="input-group">
        <input
          type="number"
          class="form-control"
          [value]="height"
          (input)="onDropHeightChange($event)"
          min="0"
          step="1"
          [placeholder]="defaultHeight.toString()"
          [disabled]="!canEdit"
        />
        <button
          class="btn btn-outline-secondary"
          (click)="clearDropHeight()"
          [disabled]="!height || !canEdit"
        >
          <i class="bi bi-x"></i>
        </button>
      </div>
      <small class="form-text text-muted">
        Effective: {{ getEffectiveHeight() }}cm @if (!height) { (using planogram
        default) }
      </small>
    </div>

    <!-- Drop Width -->
    <div class="col-md-6 mb-3">
      <label class="form-label">Width (cm)</label>
      <div class="input-group">
        <input
          type="number"
          class="form-control"
          [value]="width"
          (input)="onDropWidthChange($event)"
          min="0"
          step="1"
          [placeholder]="defaultWidth.toString()"
          [disabled]="!canEdit"
        />
        <button
          class="btn btn-outline-secondary"
          (click)="clearDropWidth()"
          [disabled]="!width || !canEdit"
        >
          <i class="bi bi-x"></i>
        </button>
      </div>
      <small class="form-text text-muted">
        Effective: {{ getEffectiveWidth() }}cm @if (!width) { (using planogram
        default) }
      </small>
    </div>
  </div>

  <div class="row">
    <!-- Drop Depth -->
    <div class="col-md-6 mb-3">
      <label class="form-label">Depth (cm)</label>
      <div class="input-group">
        <input
          type="number"
          class="form-control"
          [value]="depth"
          (input)="onDropDepthChange($event)"
          min="0"
          step="0.1"
          [placeholder]="defaultDepth.toString()"
          [disabled]="!canEdit"
        />
        <button
          class="btn btn-outline-secondary"
          (click)="clearDropDepth()"
          [disabled]="!depth || !canEdit"
        >
          <i class="bi bi-x"></i>
        </button>
      </div>
      <small class="form-text text-muted">
        Effective: {{ getEffectiveDepth() }}cm @if (!depth) { (using planogram
        default) }
      </small>
    </div>

    <!-- Footer Height -->
    <div class="col-md-6 mb-3">
      <label class="form-label">Footer Height (cm)</label>
      <div class="input-group">
        <input
          type="number"
          class="form-control"
          [value]="footerHeight"
          (input)="onDropFooterHeightChange($event)"
          min="0"
          step="1"
          [placeholder]="defaultFooterHeight.toString()"
          [disabled]="!canEdit"
        />
        <button
          class="btn btn-outline-secondary"
          (click)="clearDropFooterHeight()"
          [disabled]="footerHeight === null || !canEdit"
        >
          <i class="bi bi-x"></i>
        </button>
      </div>
      <small class="form-text text-muted">
        Effective: {{ getEffectiveFooterHeight() }}cm @if (footerHeight ===
        null) { (using planogram default) }
      </small>
    </div>
  </div>

  <div class="row">
    <!-- Lip Height -->
    <div class="col-md-6 mb-3">
      <label class="form-label">Lip Height (cm)</label>
      <div class="input-group">
        <input
          type="number"
          class="form-control"
          [value]="lipHeight"
          (input)="onDropLipHeightChange($event)"
          min="0"
          step="1"
          [placeholder]="defaultLipHeight.toString()"
          [disabled]="!canEdit"
        />
        <button
          class="btn btn-outline-secondary"
          (click)="clearDropLipHeight()"
          [disabled]="lipHeight === null || !canEdit"
        >
          <i class="bi bi-x"></i>
        </button>
      </div>
      <small class="form-text text-muted">
        Effective: {{ getEffectiveLipHeight() }}cm @if (lipHeight === null) {
        (using planogram default) }
      </small>
    </div>

    <!-- Min Spacing -->
    <div class="col-md-6 mb-3">
      <label class="form-label">Minimum Spacing (cm)</label>
      <div class="input-group">
        <input
          type="number"
          class="form-control"
          [value]="minSpacing"
          (input)="onDropMinSpacingChange($event)"
          min="0"
          step="0.1"
          [placeholder]="defaultMinimumSpacing.toString()"
          [disabled]="!canEdit"
        />
        <button
          class="btn btn-outline-secondary"
          (click)="clearDropMinSpacing()"
          [disabled]="minSpacing === null || !canEdit"
        >
          <i class="bi bi-x"></i>
        </button>
      </div>
      <small class="form-text text-muted">
        Effective: {{ getEffectiveMinSpacing() }}cm @if (minSpacing === null) {
        (using planogram default) }
      </small>
    </div>
  </div>

  <!-- Drop Alignment -->
  <div class="mb-4">
    <label class="form-label">Drop Alignment</label>
    <select
      class="form-select"
      [(ngModel)]="alignment"
      (ngModelChange)="onAlignmentChange($event)"
      [disabled]="!canEdit"
    >
      <option [value]="DropAlignment.SPACE_BETWEEN">Space Between</option>
      <option [value]="DropAlignment.TOP">Top</option>
      <option [value]="DropAlignment.BOTTOM">Bottom</option>
    </select>
  </div>

  <!-- Shelf Settings -->
  <div class="shelf-settings">
    <h5 class="mb-3">Shelf Settings</h5>

    <div class="table-responsive">
      <table class="table table-bordered">
        <thead>
          <tr>
            <th>Shelf #</th>
            <th>Depth (cm)</th>
            <th>Min Height (cm)</th>
            <th>Text</th>
          </tr>
        </thead>
        <tbody>
          @for (shelf of shelves; track shelf; let i = $index) {
          <tr>
            <td>{{ startingShelfNumber + shelves.length - i - 1 }}</td>
            <td>
              <div class="input-group">
                <input
                  type="number"
                  class="form-control"
                  [value]="shelf.depth"
                  (input)="onShelfDepthChange(i, $event)"
                  min="1"
                  step="0.1"
                  [placeholder]="getEffectiveDepth().toString()"
                  [disabled]="!canEdit"
                />
                <button
                  class="btn btn-outline-secondary"
                  (click)="clearShelfDepth(i)"
                  [disabled]="!shelf.depth || !canEdit"
                >
                  <i class="bi bi-x"></i>
                </button>
              </div>
              <small class="form-text text-muted">
                Effective: {{ getEffectiveShelfDepth(i) }}cm
              </small>
            </td>
            <td>
              <div class="input-group">
                <input
                  type="number"
                  class="form-control"
                  [value]="shelf.minHeight"
                  (input)="onShelfMinHeightChange(i, $event)"
                  min="0"
                  step="0.1"
                  [disabled]="!canEdit"
                />
                <button
                  class="btn btn-outline-secondary"
                  (click)="clearShelfMinHeight(i)"
                  [disabled]="!shelf.minHeight || !canEdit"
                >
                  <i class="bi bi-x"></i>
                </button>
              </div>
            </td>
            <td>
              <div class="input-group">
                <input
                  type="text"
                  class="form-control"
                  [value]="shelf.text"
                  (input)="onShelfTextChange(i, $event)"
                  [disabled]="!canEdit"
                />
                <button
                  class="btn btn-outline-secondary"
                  (click)="clearShelfText(i)"
                  [disabled]="!shelf.text || !canEdit"
                >
                  <i class="bi bi-x"></i>
                </button>
              </div>
            </td>
          </tr>
          }
        </tbody>
      </table>
    </div>
  </div>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-primary" (click)="confirm()" [disabled]="!canEdit">
    Save Changes
  </button>
  <button type="button" class="btn btn-secondary" (click)="cancel()">
    Cancel
  </button>
</div>
